/**
 * ARCHIVO GENERADO — no editar.
 *
 * Cada entrada apunta a un nombre de la escala, no a un número:
 *
 *     button.radius  →  radius.s  →  6
 *
 * Cambiar la escala mueve todo junto; cambiar una entrada de acá mueve solo
 * ese componente.
 */

import { tokens } from "./tokens";

type Primitivos = typeof tokens.primitives;

/**
 * El nivel 3 es una FUNCION del nivel 1, no una constante.
 *
 * Calculado una sola vez al cargar el modulo, `button.radius` quedaria fijado
 * al radio con el que se genero, y cambiar la escala no movería ni un boton:
 * la indireccion existiria en el codigo y no en el comportamiento.
 */
export const makeComponentTokens = (p: Primitivos = tokens.primitives) => {
  const { radius } = p;
  return {
    button: {
      radius: radius.s,
      paddingY: 8,
      paddingX: 16,
      fontSize: "0.875rem",
      variantPaddingLeft: 20,
    },
    card: { radius: radius.m },
    dialog: { radius: radius.l, shadow: "0 8px 24px rgba(0,0,0,0.12)" },
    chip: { radius: radius.xs, fontSize: "0.75rem" },
    tooltip: {
      radius: radius.xs,
      fontSize: "0.75rem",
      paddingY: 6,
      paddingX: 12,
    },
    input: { radius: radius.s },
    table: {
      cellPaddingY: 14,
      cellPaddingX: 16,
      fontSize: "0.875rem",
      headFontSize: "0.8125rem",
      // La única entrada del nivel 3 que no es una medida: cómo se separan las
      // filas entre sí. Se emite como el literal que eligio la autoría —no hay
      // escala de la que colgar tres alternativas excluyentes.
      rows: "linea" as "linea" | "rayado" | "limpio",
    },
  };
};

export const componentTokens = makeComponentTokens();
